import { Injectable } from '@angular/core';
import { FormSubmissionData } from './interface';

@Injectable({
  providedIn: 'root',
})
export class ContactFormCacheService {
  private cachedForm: FormSubmissionData;

  get(): FormSubmissionData {
    return this.cachedForm || ({} as FormSubmissionData);
  }

  set(data: FormSubmissionData): void {
    this.cachedForm = data;
  }
}
